import { EChatsApiPath, getChatsApiHost } from '../getChatsApiHost';

export const getFileSrc = (uid?: string | null, chatId?: string) => {
  if (!uid || !chatId) {
    return '';
  }

  const host = getChatsApiHost();

  return `${host}${EChatsApiPath.MessageFile}?fileUid=${uid}&chatId=${chatId}`;
};
